import Glide from '@glidejs/glide'
import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
  connect() {
    new Glide(this.element).mount()
  }
}